import axios from 'axios'
import { Base64 } from 'js-base64';

import config from '../config'

const agent = axios.create({
    baseURL: config.api.baseURL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
})


let unauthorised = null

const sendMail = (from, to, subject, body, access_token) => {
    const mailAgent = axios.create({
        baseURL: 'https://www.googleapis.com/gmail/v1/users/me/messages/send',
        headers: {
            "Authorization": "Bearer " + access_token,
            'HTTP-Version': 'HTTP/1.1',
            'Content-Type': 'application/json',
        },
    })

    const emailLines = [];

    emailLines.push("From: " + from);
    emailLines.push("To: " + to);
    emailLines.push('Content-type: text/html;charset=iso-8859-1');
    emailLines.push('MIME-Version: 1.0');
    emailLines.push("Subject: " + subject);
    emailLines.push("");
    emailLines.push(body);
    const email = emailLines.join("\r\n").trim();

    const base64EncodedEmail = Base64.encodeURI(email);
    base64EncodedEmail.replace(/\+/g, '-').replace(/\//g, '_')
    console.log(base64EncodedEmail)
    const data = JSON.stringify({
        "raw": base64EncodedEmail
    })
    
    return mailAgent.request({
        method: "POST",
        data
    })
}

const send = ({method, url, data, params, tokens}) => {
    const headers = tokens ? {
        'Authorization': `Bearer ${tokens.accessToken.token}`,
        'x-id-token': tokens.idToken.token
    } : {}
    return agent.request({
        method,
        // NOTE: FF was decoding |. This is why we encode the URL again here.
        url: encodeURI(url),
        headers,
        data,
        params
    })
        .catch((error) => {
            // eslint-disable-next-line no-console
            console.error('Failed to send.', error)
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx.
                throw new Error(JSON.stringify(error.response.data.message))
            } else if (error.request) {
                // The request was made but no response was received.
                throw new Error('OOPS')
            } else {
                // Something happened while setting up the request.
                throw new Error('OOPS')
            }
        })
}

const bindUnauthorised = (cb) => {
    if (unauthorised) {
        agent.interceptors.response.eject(unauthorised)
    }
    unauthorised = agent.interceptors.response.use((response) => {
        return response
    }, (error) => {
        if (error.response && error.response.status === 401 &&
            !error.response.request.responseURL.endsWith('updatepassword')) {
            cb(error)
        }
        return Promise.reject(error)
    })
}

export {
    bindUnauthorised,
    send,
    sendMail
}



// WEBPACK FOOTER //
// ./src/helpers/requests.js